export const mapTimeEntriesDto = (data) => {
    if (!Array.isArray(data)) return [];
    return data.map(dto => ({
        id: dto.id,
        userId: dto.userId,
        projectId: dto.projectId,
        projectName: dto.projectName,
        companyName: dto.companyName,
        date: dto.date,
        dayOfWeek: dto.dayOfWeek,
        startTime: dto.startTime,
        endTime: dto.endTime,
        breakMinutes: dto.breakMinutes,
        travelMinutes: dto.travelMinutes,
        kilometers: dto.kilometers,
        location: dto.location,
        comment: dto.comment,
        workTime: dto.workTime,
        activity: dto.activity,
    }));
};
